import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import Barcode from 'react-barcode'
import {Collapse} from '@chakra-ui/react'
import {
    Box,
    Text,
    IconButton,
    HStack,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, useIntl} from 'react-intl'
import {BarcodeIcon} from '../icons'

const BarcodeComponent = ({value, collapsed = true, hideLabel = false, idBottom = false}) => {
    const intl = useIntl()
    const {isOpen, onToggle} = useDisclosure({defaultIsOpen: !collapsed})
    // Prevent hydration mismatch - Barcode renders SVG which may differ between server/client
    const [hasMounted, setHasMounted] = useState(false)
    useEffect(() => {
        setHasMounted(true)
    }, [])

    // Don't render until after hydration to prevent mismatch
    if (!hasMounted) {
        return null
    }

    return (
        // data-private: barcode + loyalty ID encode the member's loyalty ID (LogRocket redaction)
        <Box data-private>
            <HStack justifyContent="space-between">
                {!idBottom && (
                    <Text variant="barcodeText">
                        {hideLabel ? value : (
                            <FormattedMessage
                                id="barcode.loyalt.id"
                                defaultMessage="Loyalty ID: {loyaltyId}"
                                values={{loyaltyId: value}}
                            />
                        )}
                    </Text>
                )}

                {collapsed && (
                    <IconButton
                        type="button"
                        variant="ghost"
                        justifyContent="flex-end"
                        minW={'24px'}
                        minH={'24px'}
                        height={'24px'}
                        width={'24px'}
                        aria-expanded={isOpen}
                        aria-label={intl.formatMessage({
                            id: 'barcode.toggle.aria_label',
                            defaultMessage: 'Show or hide loyalty barcode'
                        })}
                        icon={<BarcodeIcon />}
                        onClick={onToggle}
                    />
                )}
            </HStack>
            <Collapse in={isOpen}>
                <Box
                    sx={{
                        overflowX: 'auto',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        '.profile-barcode': {
                            height: 'auto',
                            width: '100%'
                        }
                    }}
                >
                    <Barcode
                        className="profile-barcode"
                        value={value}
                        width={3}
                        height={72}
                        displayValue={false}
                        background="white"
                        lineColor="black"
                        margin={0}
                        marginTop={10}
                        marginBottom={10}
                    />
                </Box>
            </Collapse>
            {idBottom && (
                <Text variant="barcodeText">
                    {hideLabel ? value : (
                        <FormattedMessage
                            id="barcode.loyalt.id"
                            defaultMessage="Loyalty ID: {loyaltyId}"
                            values={{loyaltyId: value}}
                        />
                    )}
                </Text>
            )}
        </Box>
    )
}

BarcodeComponent.propTypes = {
    value: PropTypes.string.isRequired,
    collapsed: PropTypes.bool,
    hideLabel: PropTypes.bool,
    idBottom: PropTypes.bool
}

export default BarcodeComponent
